import { render, staticRenderFns } from "./ac-collection-grouped-accordion.vue?vue&type=template&id=190b34a6&"
import script from "./ac-collection-grouped-accordion.vue?vue&type=script&lang=js&"
export * from "./ac-collection-grouped-accordion.vue?vue&type=script&lang=js&"
import style0 from "./ac-collection-grouped-accordion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports